import { useTracks } from '@livekit/components-react';
import { Track } from 'livekit-client';
// A main track in this context is a camera track for users with camera on,
// and microphone track (or placeholder) for everyone else
export function useMainParticipantTracks() {
    const cameraTracks = useTracks([Track.Source.Camera]);
    // If a user joins without a published microphone track,
    // a placeholder track is returned.
    const micTracks = useTracks([
        { source: Track.Source.Microphone, withPlaceholder: true },
    ]);
    const allTracks = [];
    for (let i = 0; i < micTracks.length; i++) {
        const micTrack = micTracks[i];
        if (micTrack.participant.attributes.video_role !== 'OBSERVER') {
            const participant = micTrack.participant.identity;
            const cameraTrack = cameraTracks.find((track) => {
                var _a;
                return track.participant.identity === participant &&
                    !((_a = track.publication.track) === null || _a === void 0 ? void 0 : _a.isMuted);
            });
            allTracks.push(cameraTrack || micTrack);
        }
    }
    return allTracks;
}
